<template>
  <div>
      <multiselect
              :class="{
                 active: !!currentUspCompetitor,
                 blue: true,
                 'usp__multiselect--left': uspListId === 0
              }"
              :value="currentUspCompetitor"
              :options="currentUspCompetitorOptions"
              :multiple="false"
              :clear-on-select="true"
              :preserve-search="false"
              deselect-label="✓"
              select-label=""
              selectedLabel="✓"
              placeholder="Выберите рекламодателя"
              label="title"
              :searchable="false"
              track-by="id"
              @input="onCompetitorInput"
          ></multiselect>
    <!-- Область скролла: прелоадер, результаты, сообщение об ошибке (multiselect остаётся зафиксированным сверху) -->
    <div class="usp__list-scroll">
      <individual-preloader :loading="currentUspIsLoading"/>
      <div class="usp__results" v-if="currentUspCompetitor && currentUspItems && currentUspItems.length > 0">
        <div class="usp__block" v-for="upsBlock in currentUspItems" :key="upsBlock[0]">
          <div class="usp__date">
            <b>{{ formatPeriod(upsBlock[0]) }}</b>
          </div>
          <div
            v-for="(entry, idx) in upsBlock[1]"
            :key="idx"
            class="usp_text"
            :class="statusClass(entry)"
          >
            <template v-if="typeof entry === 'object' && entry.ad_usp != null">
              <div class="usp_text__cell usp_text__cell--text">
                <span class="usp_text__bullet" :class="statusClass(entry)"></span>
                <!-- Гиперссылки: заголовки (ad_url_full) и быстрые ссылки (ad_quick_links_url) -->
                <a
                  v-if="hasLinkUrl(entry)"
                  :href="entry.ad_entity_url"
                  target="_blank"
                  rel="noopener noreferrer"
                  :title="linkTitle"
                  class="usp_text__link"
                >{{ entry.ad_usp }}</a>
                <template v-else>{{ entry.ad_usp }}</template>
              </div>
              <div class="usp_text__cell usp_text__cell--pct">
                {{ entry.frequency_pct }}%
              </div>
            </template>
            <template v-else>
              <div class="usp_text__cell usp_text__cell--text">{{ entry }}</div>
              <div class="usp_text__cell usp_text__cell--pct"></div>
            </template>
          </div>
        </div>
      </div>
      <div v-else-if="currentUspCompetitor && !currentUspIsLoading && (!currentUspItems || currentUspItems.length === 0)" class="d-flex justify-content-center flex-wrap py-3">
        <div class="error">
          <img :src="require(`../../img/error.svg`)" alt="error" class="error__image__left">
          За выбранный период данные отсутствуют
          <img :src="require(`../../img/error.svg`)" alt="error" class="error__image__right">
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Multiselect from "vue-multiselect";
import {mapActions, mapGetters} from "vuex";
import Preloader from "../common/Preloader";
import IndividualPreloader from "../common/IndividualPreloader";

export default {
  name: "UspResult",
  components: { Multiselect, Preloader, IndividualPreloader },
  props: {
    uspListId: {
      type: [Number, String],
      default: null
    }
  },
  data(){
    return {
      projectsList: [],
      selectedAdvertiser: {},
      optionsAdvertisers: [],
    }
  },
  computed: {
    // ...mapGetters('usp')
    // a computed getter
    ...mapGetters(["competitors"]),
    ...mapGetters("usp", [
        "uspLists"
    ]),
    ...mapGetters("filters", ["competitorsFilter", "dateRange"]),
    currentUspList() {
      if ((this.uspListId !== null && this.uspListId >= 0) && this.uspLists.length > this.uspListId){
        return this.uspLists[this.uspListId];
      }
   },
    currentUspItems() {
        if (this.currentUspList && !this.currentUspList.loading) {
          return this.currentUspList.items || null
        } else {
          return []
        }
      },
    currentUspCompetitor(){
        if (this.currentUspList){
          return this.currentUspList.selectedCompetitor
        } else {
          return null
          }
      },
    currentUspCompetitorOptions(){
        if (this.currentUspList) {
          let selectedCompetitorOptions = [];
          this.competitors.forEach(competitor => {
            selectedCompetitorOptions.push(Object.assign({}, {id: competitor.id,
            title: competitor.title, uspId: this.currentUspList.uspId}))})
          return selectedCompetitorOptions
        } else {
          return null
        }
      },
    currentUspIsLoading(){
        if (this.currentUspList){
          return  this.currentUspList.loading
        } else {
          return null
        }
      },
    linkTitle() {
      return "Открыть в новой вкладке";
    },
  },
  methods: {
    ...mapActions("usp", ["selectUspCompetitor"]),
    ...mapActions("filters", ["selectCompetitorsFilter"]),
    /** Есть ли URL для гиперссылки (заголовки и быстрые ссылки). */
    hasLinkUrl(entry) {
      const url = entry && entry.ad_entity_url;
      return typeof url === "string" && url.length > 0;
    },
    onCompetitorInput(competitor) {
      this.selectUspCompetitor({ competitor, uspListId: this.uspListId });
    },
    formatDate(isoDate) {
      if (!isoDate) return "";
      return isoDate.split("-").reverse().join(".");
    },
    /** Период по ключу группы; ограничиваем отображение выбранным диапазоном (не показывать 04.01 при выборе с 05.01). */
    formatPeriod(groupKey) {
      if (!groupKey) return "";
      const windowStart = new Date(groupKey + "T00:00:00Z");
      if (isNaN(windowStart.getTime())) return groupKey;
      const windowEnd = new Date(windowStart);
      windowEnd.setUTCDate(windowEnd.getUTCDate() + 2);
      let displayStart = windowStart;
      let displayEnd = windowEnd;
      if (this.dateRange && this.dateRange.startDate && this.dateRange.endDate) {
        const periodStart = new Date(this.dateRange.startDate);
        periodStart.setUTCHours(0, 0, 0, 0);
        const periodEnd = new Date(this.dateRange.endDate);
        periodEnd.setUTCHours(0, 0, 0, 0);
        if (windowStart < periodStart) displayStart = periodStart;
        if (windowEnd > periodEnd) displayEnd = periodEnd;
        if (displayStart > displayEnd) displayEnd = displayStart;
      }
      const fmt = (d) => {
        const dd = String(d.getUTCDate()).padStart(2, "0");
        const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
        return `${dd}.${mm}`;
      };
      return `${fmt(displayStart)} - ${fmt(displayEnd)}`;
    },
    statusClass(entry) {
      if (typeof entry !== "object" || entry == null) return "";
      switch (entry.status) {
        case "new": return "usp_text--new";
        case "gone": return "usp_text--gone";
        case "active": return "usp_text--active";
        default: return "";
      }
    },
  },
}
</script>

<style scoped>
/* Невидимая таблица: широкая колонка — кружок + текст, узкая — проценты */
.usp_text {
  display: table;
  width: 90%;
  table-layout: fixed;
}
.usp_text__cell {
  display: table-cell;
  vertical-align: middle;
}
.usp_text__cell--text {
  padding-right: 0.5rem;
}
.usp_text__cell--pct {
  width: 1%;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
  font-weight: 700;
}
.usp_text__bullet {
  display: inline-block;
  width: 0.6em;
  height: 0.6em;
  border-radius: 50%;
  margin-right: 0.35em;
  vertical-align: middle;
}
.usp_text--new .usp_text__bullet { background: #28a745; }
.usp_text--gone .usp_text__bullet { background: #dc3545; }
.usp_text--active .usp_text__bullet { background: #212529; }
.usp_text__link {
  color: #212529;
  text-decoration: none;
  cursor: pointer;
}
.usp_text__link:hover {
  text-decoration: underline;
}
</style>
